import * as XLSX from "xlsx";
import * as XlsxPopulate from "xlsx-populate/browser/xlsx-populate";

export const handleExport = (
  sheetName,
  titleName,
  data,
  column,
  startLine = 4
) => {
  const lastCol = column[column.length - 1].label;
  const title = [{ A: titleName }, {}];
  const finalData = [...title, ...data];
  const wb = XLSX.utils.book_new();
  const sheet = XLSX.utils.json_to_sheet(finalData, {
    skipHeader: true,
  });

  XLSX.utils.book_append_sheet(wb, sheet, sheetName);
  // binary large object
  // Since blobs can store binary data, they can be used to store images or other multimedia files.
  const workbookBlob = workbook2blob(wb);
  const dataInfo = {
    titleCell: "A2",
    titleRange: `A1:${lastCol}2`,
    tbodyRange: `A${startLine}:${lastCol}${finalData.length}`,
    theadRange: `A3:${lastCol}3`,
    theadRange2: `A4:${lastCol}4`,
  };

  return addStyle(workbookBlob, dataInfo, column, startLine);
};
const workbook2blob = (workbook) => {
  const wopts = {
    bookType: "xlsx",
    bookSST: false,
    type: "binary",
  };

  const wbout = XLSX.write(workbook, wopts);

  // The application/octet-stream MIME type is used for unknown binary files.
  // It preserves the file contents, but requires the receiver to determine file type,
  // for example, from the filename extension.
  const blob = new Blob([s2ab(wbout)], {
    type: "application/octet-stream",
  });

  return blob;
};

const s2ab = (s) => {
  // The ArrayBuffer() constructor is used to create ArrayBuffer objects.
  // create an ArrayBuffer with a size in bytes
  const buf = new ArrayBuffer(s.length);
  //create a 8 bit integer array
  const view = new Uint8Array(buf);
  //charCodeAt The charCodeAt() method returns an integer between 0 and 65535 representing the UTF-16 code
  for (let i = 0; i !== s.length; ++i) {
    view[i] = s.charCodeAt(i);
  }
  return buf;
};

const addStyle = (workbookBlob, dataInfo, columns, startLine) => {
  return XlsxPopulate.fromDataAsync(workbookBlob).then((workbook) => {
    workbook.sheets().forEach((sheet) => {
      sheet.usedRange().style({
        fontFamily: "Arial",
        verticalAlignment: "center",
      });

      columns.forEach((item) => {
        sheet.column(item.label).width(parseInt(item.width));
      });

      sheet.range(dataInfo.titleRange).merged(true).style({
        bold: true,
        horizontalAlignment: "center",
        verticalAlignment: "center",
      });
      if (dataInfo.tbodyRange) {
        sheet.range(dataInfo.tbodyRange).style({
          horizontalAlignment: "center",
          fontSize: 11,
          border: {
            top: { style: "thin", color: { auto: 1 } },
            right: { style: "thin", color: { auto: 1 } },
            bottom: { style: "thin", color: { auto: 1 } },
            left: { style: "thin", color: { auto: 1 } },
          },
        });
      }

      sheet.range(dataInfo.theadRange).style({
        fill: "808080",
        bold: true,
        horizontalAlignment: "center",
        fontColor: "ffffff",
      });

      if (startLine === 5) {
        sheet.range(dataInfo.theadRange2).style({
          fill: "7da358",
          bold: true,
          horizontalAlignment: "center",
          fontColor: "ffffff",
        });
      }
    });

    return workbook
      .outputAsync()
      .then((workbookBlob) => URL.createObjectURL(workbookBlob));
  });
};
